// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3GohB","disabled":"FileBtn_disabled__3_dAM","warn":"FileBtn_warn__ZEP3c","fade":"FileBtn_fade__3wClQ"};